import { Download, X } from 'lucide-react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useEscapeLayer } from '../lib/escape';

/**
 * Imagem em tela cheia por cima do atendimento (como no WhatsApp): fecha no X, no Esc ou clicando
 * fora da imagem. `url` é o blob: já baixado com o token.
 */
export function ImageViewer({ url, name, caption, onClose }: { url: string; name: string; caption?: string | null; onClose: () => void }) {
  useEscapeLayer(true, onClose);
  useEffect(() => {
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = overflow;
    };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[100] flex flex-col bg-black/90" role="dialog" aria-modal="true" aria-label={name} onClick={onClose}>
      <div className="flex items-center gap-2 px-4 py-3 text-white" onClick={(e) => e.stopPropagation()}>
        <span className="min-w-0 flex-1 truncate text-sm opacity-80">{name}</span>
        <a href={url} download={name} className="rounded-full p-2 hover:bg-white/10" title="Baixar" aria-label="Baixar imagem">
          <Download className="size-5" />
        </a>
        <button className="rounded-full p-2 hover:bg-white/10" onClick={onClose} title="Fechar (Esc)" aria-label="Fechar" autoFocus>
          <X className="size-6" />
        </button>
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center px-4 pb-4">
        <img src={url} alt={name} className="max-h-full max-w-full rounded object-contain shadow-2xl" onClick={(e) => e.stopPropagation()} />
      </div>
      {caption && (
        <div className="px-4 pb-5 text-center text-sm whitespace-pre-wrap text-white/90" onClick={(e) => e.stopPropagation()}>
          {caption}
        </div>
      )}
    </div>,
    document.body,
  );
}
